import "@hotwired/turbo"
import { Application } from "@hotwired/stimulus"
import controllers from "./controllers/index"

// jQuery must be set globally BEFORE bootstrap (ESM imports hoist, so we use a side-effect module)
import "./jquery-global"
import "bootstrap-sass/assets/javascripts/bootstrap"
import $ from "jquery"

// LightGallery v2 (vanilla JS, no jQuery needed)
import lightGallery from "lightgallery"

const application = Application.start()
controllers.forEach(({ identifier, controllerConstructor }) => {
  application.register(identifier, controllerConstructor)
})

// Initialize features after Turbo navigation and initial load
document.addEventListener("turbo:load", init)
document.addEventListener("DOMContentLoaded", init)

function init() {
  initLightGallery()
  initScrolledNavbar()
  initProductFilter()
  initShareButtons()
}

// Re-render AddToAny share buttons after Turbo navigation (page.js is loaded
// once in the layout head; init_all() rescans the new DOM for .a2a_kit nodes)
function initShareButtons() {
  if (window.a2a) window.a2a.init_all()
}

function initLightGallery() {
  document.querySelectorAll(".product-detail__gallery, .gallery-column, .lightbox").forEach(el => {
    lightGallery(el, {
      selector: "a",
      thumbnail: false,
      animateThumb: false,
      showThumbByDefault: false,
      download: false,
      hideBarsDelay: 30000,
    })
  })
}


function initScrolledNavbar() {
  const navbar = document.querySelector(".block--sub-navbar")
  if (!navbar) return

  function checkScrolled() {
    navbar.classList.toggle("scrolled", window.scrollY >= 355)
  }

  checkScrolled()
  window.addEventListener("scroll", checkScrolled, { passive: true })
}

function initProductFilter() {
  const filterForm = document.querySelector("form#product-filter")
  if (!filterForm) return

  const activeList = filterForm.querySelector(".tab-active-filters ul.slected")

  // Restore active tab from URL param
  const urlTab = new URLSearchParams(window.location.search).get("tab")
  if (urlTab) {
    filterForm.querySelectorAll(".nav-tabs li").forEach(li => li.classList.remove("active"))
    filterForm.querySelectorAll(".tab-pane").forEach(pane => pane.classList.remove("active"))
    const tabLink = filterForm.querySelector(`.nav-tabs a[href='#${urlTab}']`)
    if (tabLink) {
      tabLink.closest("li").classList.add("active")
      const pane = filterForm.querySelector(`#${urlTab}`)
      if (pane) pane.classList.add("active")
    }
  }

  // Track active tab in hidden input so it's included in form submission
  let tabInput = filterForm.querySelector("input[name='tab']")
  if (!tabInput) {
    tabInput = document.createElement("input")
    tabInput.type = "hidden"
    tabInput.name = "tab"
    tabInput.value = urlTab || filterForm.querySelector(".nav-tabs li.active a")?.getAttribute("href")?.replace("#", "") || ""
    filterForm.appendChild(tabInput)
  }

  filterForm.querySelectorAll(".nav-tabs a[data-toggle='tab']").forEach(link => {
    link.addEventListener("click", () => {
      tabInput.value = link.getAttribute("href").replace("#", "")
    })
  })

  function updateTabBadges() {
    filterForm.querySelectorAll(".nav-tabs a[data-toggle='tab']").forEach(link => {
      const paneId = link.getAttribute("href").replace("#", "")
      const pane = filterForm.querySelector(`#${paneId}`)
      if (!pane) return
      const count = pane.querySelectorAll("input[type=checkbox]:checked").length
      let badge = link.querySelector(".filter-badge")
      if (count > 0) {
        if (!badge) {
          badge = document.createElement("span")
          badge.className = "filter-badge"
          link.appendChild(badge)
        }
        badge.textContent = count
      } else {
        badge?.remove()
      }
    })
  }

  function updateActiveFilters() {
    if (!activeList) return
    const items = Array.from(filterForm.querySelectorAll("input[type=checkbox]:checked")).map(cb => {
      const label = cb.closest("label") || cb.parentElement
      const labelText = label ? (label.dataset.label || label.textContent.trim()) : cb.value
      return `<li><span class='btn btn-remove btn-xs' data-checkbox='${cb.value}'>${labelText}</span></li>`
    })
    activeList.innerHTML = items.join("")
    updateTabBadges()
  }

  filterForm.querySelectorAll("input[type=checkbox]").forEach(cb => {
    cb.addEventListener("change", updateActiveFilters)
  })

  updateTabBadges()

  document.addEventListener("click", e => {
    const btn = e.target.closest("[data-checkbox]")
    if (!btn || !filterForm.contains(btn)) return
    e.preventDefault()
    const value = btn.dataset.checkbox
    const cb = filterForm.querySelector(`input[type='checkbox'][value='${value}']`)
    if (cb) {
      cb.checked = false
      cb.dispatchEvent(new Event("change"))
    }
    btn.closest("li")?.remove()
  })
}
